export const AUTH_TOKEN_KEY = 'imanyat-api-token'
export const AUTH_USER_KEY = 'imanyat-auth-user'
export const PLAYER_CURRENT_TRACKLIST = 'imanyat-player-current-tracklist'
export const PLAYER_CURRENT_TRACK = 'imanyat-player-current-track'
export const PLAYER_CURRENT_TRACK_ID = 'imanyat-player-current-track-id'
export const PLAYER_CURRENT_TRACK_INDEX = 'imanyat-player-current-track-index'
export const PLAYER_SHOW_MINIMIZED_PLAYER = 'imanyat-player-show-minimized-player'
export const PLAYER_OPTION_REPEAT = 'imanyat-player-option-repeat'
export const PLAYER_OPTION_SHUFFLE = 'imanyat-player-option-shuffle'
export const PLAYER_IS_PLAYING = 'imanyat-player-is-playing'